
import React from 'react';
import { FacilityOrderPatientNewFlowInsuranceNoteModalTemplate } from 'themes/application/facility-order-new-flow-insurance/components';
import { observer } from 'mobx-react';
import { setCurrentView } from 'core/utils';
import { FacilityOrderPatientNewFlowInsuranceNoteModalStore } from 'application/facility-order-new-flow-insurance/stores';

@setCurrentView((rootStore, componentProps) => new FacilityOrderPatientNewFlowInsuranceNoteModalStore(rootStore, componentProps), 'facilityOrderPatientNewFlowInsuranceNoteModalStore')
@observer
class FacilityOrderPatientNewFlowInsuranceNoteModal extends React.Component {
    render() {
        return <FacilityOrderPatientNewFlowInsuranceNoteModalTemplate {...this.props} />
    }
}

export default FacilityOrderPatientNewFlowInsuranceNoteModal;
